<template>
  <div class="pc3-sidebar-container" :style="sidebarContainer">
    <div :class="{asideisclose:isCollapse}" style="position: relative;height:100%;">
      <div class="pc3-sidebar-image" :style="sidebarImageStyle"></div>

      <!-- <div
        class="logo"
        :style="{'width': this.$store.state.core.maxMenuWidth,'transition': 'all 0.3s ease','backgroundImage': `url(${$store.state.core.logoUrl})`}"
      >
        <div class="system_name">{{systemName}}</div>
      </div>-->
      <div class="pc3-menu-isCollapse" :style="{'z-index':$store.state.core.thema == 'blue'?'':'-2'}" :class="[isCollapse?'':'scale-in-hor-left',$store.state.core.thema == 'blue'?'pc3blue-menu-isCollapse':'fx__bgcolor']" v-show="menus.length > 0" @click="onToggleMenu(!isCollapse)">
        <span class="fa fa-chevron-right" :style="{transform:isCollapse? 'rotate(0)':'rotate(181deg)', transition: 'transform 0.3s ease 0.2s',}"></span>
      </div>
      <aside class="pc3-menu-wrapper" :style="wrapStyle">
        <!--dx  logo增加下划线 -dx_border-botton-->
        <!-- :class="{'fx__item-selected':currentActive==item.name,'pc3blue-menu-item':$store.state.core.thema == 'blue'}" -->
        <div class="pc3-menu-content menu-scroll" :style="contentStyle">
          <ul style="margin:5px 8px">
            <li class="pc3-menu" :class="[item.children&&item.children.some(p=>p.name == currentActive)?($store.state.core.thema == 'blue'?'pc3blue-menu-submenu-selected':''):'']" v-for="(item,index) in menus" :key="index">
              <div class="pc3-menu-item" :class="[$store.state.core.thema == 'blue'?'pc3blue-menu-item':'',currentActive==item.name?($store.state.core.thema == 'blue'?'pc3blue-menu-item-selected':'fx__item-selected'):'']" v-if="!item.children" v-show="!isCollapse" @click="onSelect(item.name)">
                <i :class="item.icon" class="fa-lg"></i>
                <span :style="{'margin-left':item.icon?'':'40px'}" class="pc3-item-title" :title="item.text">{{item.text}}</span>
              </div>
              <!-- item.children&&item.children.some(p=>p.name == currentActive)?($store.state.core.thema == 'blue'?'pc3blue-menu-submenu-selected':'fx-color-brand'):'' -->
              <div class="pc3-menu-submenu-title pc3-menu-submenu" :class="[$store.state.core.thema == 'blue'?'pc3blue-menu-item':'',item.children.some(p=>p.name == currentActive)?($store.state.core.thema == 'blue'?'':'fx-color-brand'):'']" v-else v-show="!isCollapse" @click="isOpen(item,index)">
                <i :class="item.icon" class="fa-lg"></i>
                <span :style="{'margin-left':item.icon?'':'40px'}" class="pc3-item-title" :title="item.text">{{item.text}}</span>
                <i class="fa fa-angle-right fa-lg" :class="{'pc3-menu-submenu-title-icon-rotate':item.isfold,'pc3-menu-submenu-title-icon':!item.isfold}"></i>
              </div>
              <ul :class="[item.isfold?'pc3-ivu-menu-item-group-open':'pc3-ivu-menu-item-group-close']" v-if="item.children&&item.children.length>0">
                <li class="pc3-menu-submenu-item" style="margin: 0 10px;" v-for="(child,index2) in item.children" :key="index2" @click="onSelect(child.name)" v-show="!isCollapse" :class="[$store.state.core.thema == 'blue'?'pc3blue-menu-submenu-item':'',]">
                  <div :class="[currentActive==child.name?($store.state.core.thema == 'blue'?'pc3blue-menu-submenu-item-selected':'fx__item-selected'):'']" class="fx__hover" style="width: 100%;display: flex;align-items: center;padding: 10px 20px 10px 30px;position: relative;">
                    <i :class="child.icon" class="fa-lg"></i>
                    <span :style="{'margin-left':child.icon?'':'30px'}" class="pc3-item-submenu-title" :title="child.text">{{child.text}}</span>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <!-- <div class="pc3-menu-trigger">
          <span @click="onToggleMenu">
            <i class="fa" :class="`fa-${isCollapse? 'indent' :'outdent'}`"></i>
          </span>
        </div>-->
      </aside>
    </div>
  </div>
</template>
<script>
import SvgIcon from "./svgIcon"

function findRoute(arr, parent, name) {
  if (!arr) return false
  for (let i = 0, len = arr.length; i < len; i++) {
    let t = arr[i]
    if (t.name === name) {
      return {
        parent: parent,
        route: t,
      }
    } else if (t.children && t.children.length > 0) {
      t = findRoute(t.children, t, name)
      if (t) return t
    }
  }
  return null
}

export default {
  components: { SvgIcon },
  props: {
    width: {
      type: Number,
      default: 280,
    },
    backgroundColor: {
      type: String,
      default: "#2C2E48",
    },
    color: {
      type: String,
      default: "#b9bbbe",
    },
    activeColor: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    let _this = this
    return {
      accordion: true,
      systemName: this.$app.ProjSetting.title, //从配置里取title
      isCollapse: false,
      menus: [],
      wrapStyle: {
        width: this.width + "px",
        // backgroundColor: this.backgroundColor
        // backgroundColor: "rgba(27,27,27,.74)"
      },
      contentStyle: {
        // width: this.width + "px",
      },
      menuStyle: {
        // backgroundColor: this.backgroundColor,
        backgroundColor: "transparent",
        width: this.width + 1 + "px",
        // color: this.color
      },
      svgStyle: {
        fill: this.color,
      },
      currentActive: "",
      defaultOpeneds: [],
      openedMenuIndex: [],
      openLocked: true,
      sidebarImageStyle: {
        height: 100 + "%",
        width: 100 + "%",
        position: "absolute",
        top: 0,
        left: 0,
        backgroundImage: _this.$store.state.core.thema == "blue" ? "" : ` url('${_this.$store.state.core.pc2.sideBarImg}')`,
        zIndex: -1,
      },
      sidebarContainer: {
        width: this.width + "px",
      },
    }
  },
  watch: {
    $route: {
      handler: "routeChange",
    },
    menus: {
      handler: function (newVal, oldVal) {
        if (newVal && newVal.length > 0) {
          this.onToggleMenu(false)
        } else {
          this.onToggleMenu(true)
        }
      },
      immediate: true,
    },
  },
  mounted() {
    let _this = this
    let fd = this.$app.event.on("changePC3SideBar", function (menu) {
      _this.menus = menu.children || []
      _this.routeChange()
    })
    _this.$once("hook:beforeDestroy", () => {
      sessionStorage.removeItem("PC3menukey")
      fd.dispose()
    })

    // fd.dispose()
  },
  methods: {
    isOpen(item, index) {
      item.isfold = !item.isfold
      this.$set(this.menus, index, item)
    },
    swichfold() {
      let grid = this.$refs.grid
      grid.groups.forEach((element) => {
        element.isfold = !element.isfold
      })
    },
    routeChange() {
      const { name } = this.$route
      // const p_obj = findRoute(this.menus, null, name)
      // const indexes = []
      // if (p_obj && p_obj.parent) indexes.push(p_obj.parent.menukey)
      const p_arr = this.menus
      const indexes = []
      // if (p_arr && p_arr.length > 0) {
      //   for (const [index, item] of p_arr.entries()) {
      //     if (item.children && item.children.length > 0) {
      //       indexes.push(item.menukey)
      //     }
      //   }
      // }
      // this.defaultOpeneds = indexes
      // this.openedMenuIndex = indexes
      this.currentActive = name
      // this.$nextTick(() => {
      //   this.$refs["menu"].updateOpened()
      //   this.$refs["menu"].updateActiveName()
      // })
    },
    onMenuOpenAndClose(openids) {
      this.openedMenuIndex = openids
    },
    // onMouseAction() {
    //   if (this.openLocked) return
    //   this.onToggleMenu(false)
    // },
    onSelect(name) {
      // let { parent, route } = findRoute(this.menus, null, name);
      // if (!parent) {
      //   this.$nextTick(() => {
      //     // this.defaultOpeneds = [];
      //     this.openedMenuIndex = [];
      //     this.$refs.menu.updateOpened();
      //   });
      // }
      this.$app.routeMenuTo(name)
    },
    onToggleMenu(lock = true) {
      this.isCollapse = lock
      // if (lock !== false) {
      //   this.openLocked = lock
      // }
      // 展开
      if (!this.isCollapse) {
        this.wrapStyle = {
          width: this.width + "px",
          // backgroundColor: "rgba(27,27,27,.74)",
          position: "absolute",
        }
        this.sidebarContainer.width = this.width + "px"
        this.$store.commit("core/setMenuWidthforPc3", "280px")
        this.defaultOpeneds = [...this.openedMenuIndex]
      } else {
        //收起
        this.sidebarContainer.width = "0px"
        this.wrapStyle.width = "0px"
        this.defaultOpeneds = []
        this.$store.commit("core/setMenuWidthforPc3", "0px")
      }
      // this.$nextTick(() => {
      //   this.$refs.menu.updateOpened()
      // })
    },
  },
}
</script>
<style lang="scss">
.pc3-menu-content {
  .ivu-menu,
  .ivu-menu-item {
    // color: #b9bbbe;
  }
  .ivu-menu-submenu-title,
  .ivu-menu-item {
    margin: 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ivu-menu-submenu-title,
  .ivu-menu-item,
  .pc3-item-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: 30px;
  }

  > ul {
    > li {
      .pc3-item-icon {
        & + .pc3-item-title {
          margin-left: 16px;
        }
      }
    }
  }

  .ivu-menu li {
    .ivu-menu {
      .pc3-item-icon {
        left: 34px;
        & + .pc3-item-title {
          margin-left: 16px;
        }
      }
    }
  }

  .ivu-menu-vertical .ivu-menu-item,
  .ivu-menu-vertical .ivu-menu-submenu-title {
    padding: 14px 16px;
    display: flex;
  }

  .ivu-menu-vertical .ivu-menu-item:hover,
  .ivu-menu-vertical .ivu-menu-submenu-title:hover {
    // color: #4caf50;
  }

  .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
    // content: '';
    display: none;
  }

  .ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
    // color: #fff !important;
    // box-shadow: 0 6px 12px 0 rgba(31, 72, 33, 0.75);
    // border-radius: 4px;
    // background: #4caf50;
  }
}
</style>
<style lang="scss" scoped>
.pc3-menu {
  display: block;
  margin: 0;
  padding: 0;
  outline: 0;
  list-style: none;
  // font-size: 14px;
  position: relative;
  z-index: 900;
  .pc3-menu-submenu {
  }
  .pc3-menu-submenu-title {
    padding: 14px 24px;
    position: relative;
    cursor: pointer;
    z-index: 1;
    // transition: all 0.2s ease-in-out;
    .pc3-menu-submenu-title-icon {
      transition: all 0.2s ease-in-out;
      position: absolute;
      top: 50%;
      right: 24px;
      transform: translateY(-50%);
    }
    .pc3-menu-submenu-title-icon-rotate {
      transition: all 0.2s ease-in-out;
      position: absolute;
      top: 50%;
      right: 24px;
      transform: translateY(-50%) rotate(90deg);
    }
  }
  .pc3-item-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    font-weight: 400;
    margin-left: 24px;
  }
  .pc3-item-submenu-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    font-weight: 400;
    margin-left: 14px;
  }
  .pc3blue-menu-submenu-item {
    color: #ffffff;
  }
  .pc3blue-menu-item {
    color: #ffffff;
  }
  .pc3blue-menu-item:hover {
    color: #ffffffcc;
  }
  .pc3blue-menu-submenu-item {
    color: #ffffff;
  }
  .pc3blue-menu-item-selected {
    background: #ffffff;
    color: #3189ff;
    border-radius: 170px;
  }
  .pc3blue-menu-item-selected:hover {
    background: #ffffff;
    color: #3189ff;
    border-radius: 170px;
  }
  .pc3blue-menu-submenu-item-selected {
    position: relative;
    border-radius: 5px;
    background: rgba(49, 137, 255, 0.1);
    &::before {
      content: "";
      position: absolute;
      border-radius: 5px;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border: 1px solid #3189ff;
    }
  }

  .pc3-menu-item {
    padding: 18px 22px;
    margin: 0 10px;
    position: relative;
    list-style: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    z-index: 1;
    // transition: all 0.2s ease-in-out;
  }
  .pc3-menu-submenu-item {
    padding: 8px 2px;
    margin: 0 10px;
    position: relative;
    list-style: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    z-index: 1;
    // transition: all 0.2s ease-in-out;
  }
}
.pc3blue-menu-submenu-selected {
  background: #ffffff;
  border-radius: 30px;

  .pc3blue-menu-item-selected {
    border-radius: 0px;
    &:hover {
      border-radius: 0px;
    }
  }
  .pc3blue-menu-item {
    color: #3189ff;
    &:hover {
      color: #3189ff;
    }
  }
  .pc3blue-menu-submenu-item {
    color: #3189ff;
    &:hover {
      color: #3189ff;
    }
  }
}
// .pc3blue-menu-submenu-selected:hover {
//   background: #ffffff;
//   border-radius: 30px;
// }
.arrow {
  width: 16px;
  text-align: center;
  margin: 0 10px;
  transition: all 0.2s;
  &.rotate180 {
    transform: rotate(180deg);
  }
}
.logo {
  position: absolute;
  // background: url("/static/img/logo-pc3.png") no-repeat 15px;
  // background: url("/static/img/logo.png") no-repeat 10px;
  background-repeat: no-repeat;
  background-position: 10px;
  height: 70px;
  z-index: 1;
  display: flex;
  align-items: center;
  .system_name {
    height: 50px;
    padding-left: 60px;
    padding-right: 10px;
    font-size: 17px;
    color: #fff;
    opacity: 1;
    // transition: opacity 0.3s ease;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    align-items: center;
    overflow: hidden;
    text-align: justify;
    white-space: nowrap;
    //   display: -webkit-box;
    //   -webkit-box-orient: vertical;
    //   -webkit-line-clamp: 3;
  }
}
.pc3-item-title {
  opacity: 1;
  // transition: opacity 0.3s ease;
}
.asideisclose {
  .logo {
    .system_name {
      opacity: 0;
    }
  }
  .pc3-item-title {
    opacity: 0;
  }
}
.pc3-menu-wrapper {
  display: flex;
  height: calc(100%);
  flex-direction: column;
  position: relative;
  transition: width 0.3s ease;
  overflow: hidden;
  // padding-top: 70px;

  .pc3-menu-content {
    overflow-y: hidden;
    overflow-x: hidden;
    flex-grow: 1;
    box-sizing: border-box;
    // border-top: 1px solid rgba(255, 255, 255, 0.1);
    &:hover {
      overflow-y: overlay;
    }
  }

  .pc3-menu-trigger {
    display: flex;
    height: 50px;
    flex-shrink: 0;
    padding-left: 20px;
    align-items: center;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
  svg {
    vertical-align: sub;

    &:hover {
      fill: #ddd !important;
      cursor: pointer;
    }
  }

  .item-title {
    margin-left: 22px;
    // transition: all 0.3s ease;
  }
}

.menu-scroll {
  // &::-webkit-scrollbar {
  //     width: 7px;
  // }

  // &::-webkit-scrollbar-track {
  //     background-color: #656990;
  //     border-left: 2px solid transparent
  // }

  // &::-webkit-scrollbar-thumb {
  //     background-color: #2C2E48;
  //     border-left: 2px solid transparent;

  //     &:window-inactive {
  //         background-color: rgba(0, 0, 0, .1)
  //     }
  // }
  &::-webkit-scrollbar {
    width: 5px;
    height: 10px;
    /**/
  }
  &::-webkit-scrollbar-thumb {
    // background: #bfbfbf;
    background: #606870;
    border-radius: 10px;
    &:hover {
      background: #606870;
    }
  }

  &::-webkit-scrollbar-corner {
    background: transparent;
  }
}
.pc3-sidebar-container {
  position: fixed;
  height: calc(100% - 70px);
  top: 70px;
  // transition: all 0.3s ease;
  z-index: 99;
  .pc3-menu-isCollapse {
    position: absolute;
    display: flex;
    align-items: center;
    width: 30px;
    height: 80px;
    padding-left: 19px;
    // background: #3189ff;
    right: -11px;
    top: calc(50% - 70px);
    cursor: pointer;
    border-radius: 3px;
    transition: all 0.3s;
    &:hover {
      transition: all 0.3s ease 0.3s;
      right: -21px;
      padding-left: 15px;
    }
  }
  .pc3blue-menu-isCollapse {
    background: #3189ff;
    color: #fff;
  }
  .scale-in-hor-left {
    -webkit-animation: scale-in-hor-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    animation: scale-in-hor-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  }

  @-webkit-keyframes scale-in-hor-left {
    0% {
      -webkit-transform: scaleX(0);
      transform: scaleX(0);
      -webkit-transform-origin: 0% 0%;
      transform-origin: 0% 0%;
      opacity: 1;
    }
    50% {
      -webkit-transform: scaleX(0);
      transform: scaleX(0);
      -webkit-transform-origin: 0% 0%;
      transform-origin: 0% 0%;
      opacity: 1;
    }
    100% {
      -webkit-transform: scaleX(1);
      transform: scaleX(1);
      -webkit-transform-origin: 0% 0%;
      transform-origin: 0% 0%;
      opacity: 1;
    }
  }
  @keyframes scale-in-hor-left {
    0% {
      -webkit-transform: scaleX(0);
      transform: scaleX(0);
      -webkit-transform-origin: 0% 0%;
      transform-origin: 0% 0%;
      opacity: 1;
    }
    50% {
      -webkit-transform: scaleX(0);
      transform: scaleX(0);
      -webkit-transform-origin: 0% 0%;
      transform-origin: 0% 0%;
      opacity: 1;
    }
    100% {
      -webkit-transform: scaleX(1);
      transform: scaleX(1);
      -webkit-transform-origin: 0% 0%;
      transform-origin: 0% 0%;
      opacity: 1;
    }
  }
}

.logo-container {
  width: 50px;
  height: 50px;
  overflow: hidden;
  display: block;
}
.pc3-sidebar-image {
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  transition: all 1s ease;
}
.pc3-item-icon {
  display: inline-block;
  min-width: 20px;
  width: 20px;
  height: 20px;
  // position: absolute;
  // left: 15px;
  // top: 14px;
}

//底部线条
.vs_border-botton {
  height: 1px;
  width: 231px;
  border-bottom: 1px solid #5b5f61;
  margin-left: 16px;
  margin-right: 13px;
}
// 权限管理图标
.fa-lock:nth-of-type(1) {
  font-size: 1.65em;
}
.pc3-ivu-menu-item-group-close {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s;
}
.pc3-ivu-menu-item-group-open {
  transition: all 0.6s;
  overflow: hidden;
  max-height: 1500px;
}
</style>